import { Box, Flex, Image as ImageComponent, Text } from '@chakra-ui/react';
import Head from 'next/head';
import router from 'next/router';
import React, { useState } from 'react'
import { AboutCard } from '../../components/AboutUs/aboutCard';
import { BreadCrumb } from '../../components/AppHeader/BreadCrumb';
import { AuthModal } from '../../components/Auth/withAuthModal';
import { PerformanceBanner, RatingBanner, UploadListingBanner } from '../../components/Banner';
import { PrimaryButton } from '../../components/button';
import { TrustedCompanies } from '../../components/Landing';
import { otherListingProperties, otherListingPropertiesTools, professionalFaq } from '../../data';
import { WrapperStyle } from '../../styles/newDesignStyles';
import { HeaderText, RealtorsHeader, RealtorsSemiHeader, SemiHeaderText } from '../../styles/typography';
import { useAuth } from '../../utils/auth/newAuth';

const PropertyOwners = () => {

    const [isAuthBoxOpen, setisAuthBoxOpen] = useState(false);
    const { user } = useAuth();

    return (
        <>

            <Head>
                <title key="title">Property Owners - Business and Commercial Real Estate Listings</title>
                <meta key="description" name="description" content="List your property where the right buyers are looking. Send in-built NDAs to keep information safe. Deal with serious buyers. List for free." />
                <meta key="og:title" property="og:title" content='Property Owners - Business and Commercial Real Estate Listings' />
                <meta key="og:description" property="og:description" content="List your property where the right buyers are looking. Send in-built NDAs to keep information safe. Deal with serious buyers. List for free." />

                <link key="fav1" rel="apple-touch-icon" sizes="180x180" href="/favicons/apple-touch-icon.png" />
                <link key="fav2" rel="icon" type="image/png" sizes="32x32" href="/favicons/favicon-32x32.png" />
                <link key="fav3" rel="icon" type="image/png" sizes="16x16" href="/favicons/favicon-16x16.png" />
                <link key="fav5" rel="mask-icon" href="/favicons/safari-pinned-tab.svg" color="#5bbad5" />
                <link key="fav6" rel="shortcut icon" href="/favicons/favicon.ico" />
                <link rel="canonical" href="https://zonado.com/who-we-help/property-owners" />
                <meta key="msFav" name="msapplication-TileColor" content="#2d89ef" />
                <meta name="msapplication-config" content="favicons/browserconfig.xml" />
                <meta name="theme-color" content="#ffffff" />

            </Head>

            <AuthModal
                createListing
                onClose={() => setisAuthBoxOpen(false)}
                isOpen={isAuthBoxOpen}
                
            />

            <WrapperStyle>

                {/* breadacrumb */}
                <BreadCrumb to={"Property owners"} />

                <Flex flexDir={{ base: "column", md: "row" }} mt={{ md: "0", lg: "50px" }} justifyContent={"space-between"} alignItems={"center"}>
                    <Flex
                        // px={{ md: "0", lg: "50px" }}
                        pt={{ base: "68px", md: "33px", lg: "26px" }}
                        pb={{ base: "0", lg: "26px" }}
                        flexDir={"column"} w={{ md: "40%", lg: "49%" }}

                    >
                        <HeaderText text={"Rise above the clutter of classifieds"} />
                        <SemiHeaderText
                            text={"Property owners in Canada struggle to generate the right kind of attention towards their assets. That’s history with Zonado."}
                        />

                        <PrimaryButton
                            mb={"36px"} label={"List for sale or lease"}
                            mr={"auto"} mt={"43px"}
                            onClick={() => user ? router.push("/add-listing") : setisAuthBoxOpen(true)}
                        />

                    </Flex>

                    <Box w={{ md: "50%" }} py={"14px"} pr={"11px"}>
                        <ImageComponent src={"/images/newLanding/propertyOwnersBaner.svg"} h={"100%"} objectFit={"contain"} w={["100%", "350px", "100%"]} mx={"auto"} />
                    </Box>
                </Flex>

                <Flex flexDir={"column"} mt={"50px"} >
                    <Text color={"gray.500"} fontSize={"16px"}>Trusted by</Text>

                    <Flex flexDir={"row"} mt={"23px"} className={"trustedCompanies"}>
                        <TrustedCompanies img={"/images/newLanding/trustedCompanies/image_2.svg"} />
                        <TrustedCompanies img={"/images/newLanding/trustedCompanies/image 4.svg"} />
                        <TrustedCompanies img={"/images/newLanding/trustedCompanies/Vector.svg"} />
                        <TrustedCompanies img={"/images/newLanding/trustedCompanies/image 30.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 7.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 3.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 6.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 22.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 5.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 8.svg"} />
                    </Flex>
                </Flex>

                <Box mt={"96px"}>
                    <RealtorsHeader
                        text={"Don’t leave money on the table when selling what you built"}
                    />
                    <RealtorsSemiHeader text={"Zonado helps business owners maximize reach among active buyers, realtors, business brokers. Sell with confidence on Zonado."}
                    />

                    <Flex mt={"56px"} flexDir={"row"} flexWrap={"wrap"} justifyContent={"space-between"}>
                        {
                            otherListingProperties.map(({ id, ...rest }) =>
                                <AboutCard
                                    key={id}
                                    item={rest}
                                />
                            )
                        }
                    </Flex>
                </Box>

                {/* performance banner */}
                <PerformanceBanner />

                {/* broker tools  */}
                <Box>
                    <RealtorsHeader text={"A powerful suite of features built for your needs"} />
                    <RealtorsSemiHeader text={"Zonado was built as a result of intensive user interviews with Commercial Real Estate agents from across Canada. The result is a suite of elegant solutions to power your workflow"} />

                    <Flex mt={"56px"} flexDir={"row"} flexWrap={"wrap"} justifyContent={"space-between"}>
                        {
                            otherListingPropertiesTools.map(({ id, ...rest }) =>
                                <AboutCard
                                    key={id}
                                    item={rest}
                                />
                            )
                        }
                    </Flex>
                </Box>

                {/* upload listing banner */}
                <UploadListingBanner
                    bannerBody={<>Upload a flyer/listing details & photos and we will put up your listing for you in less than 24 hours, <strong>free</strong>.</>}
                    bannerHeader={"Let us upload your listing for you"}
                    bannerImage={"/images/newLanding/propertyOwnersListing.png"}
                />

                {/* ratings banner */}
                <RatingBanner
                    ratingImg={"/images/newLanding/propertyOwnersTestimony.png"}
                    ratingHeader={'“Helped me generate real leads!”'}
                    review={"This is an excellent tool to use, and a great place to generate real leads! The website is so easy to use and navigate and all the information you want is built right into the platform!"}
                    reviewer={"- Asaanth Sivajohan"}
                />

            </WrapperStyle>
        </>
    )
}

export default PropertyOwners;

PropertyOwners.isProfessional = true;
PropertyOwners.faq = professionalFaq;